module.exports = __webpack_public_path__ + "img/chat-bubble.52cbfa10.svg";